import { CommonModule, Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GhostButtonType } from 'src/app/shared/components/ghost-button/ghost-button-type.enum';
import { PaymentMethodType } from 'src/app/shared/models/payment/payment-dto.model';
import { ValidationPatterns } from 'src/app/shared/validation/validation-patterns.const';
import { ChoosenPaymentType } from './choosen-payment-type.model';
import { environment } from 'src/environments/environment';
import { GhostButtonComponent } from '../ghost-button/ghost-button.component';
import { FormCheckboxComponent } from '../forms/form-checkbox/form-checkbox.component';
import { AutopayTermsComponent } from '../autopay-terms/autopay-terms.component';
import { PreventDoubleClickDirective } from '../../directives/prevent-double-click/prevent-double-click.directive';
import { Extensions } from '../../extensions/extensions';

@Component({
  selector: 'app-choose-payment-method',
  templateUrl: './choose-payment-method.component.html',
  styleUrls: ['./choose-payment-method.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GhostButtonComponent,
    AutopayTermsComponent,
    FormsModule,
    ReactiveFormsModule,
    FormCheckboxComponent,
    PreventDoubleClickDirective
  ]
})
export class ChoosePaymentMethodComponent implements OnInit {
  @Output() submitPaymentMethod: EventEmitter<ChoosenPaymentType> = new EventEmitter();
  @Input() showBackButton: boolean;
  @Input() isPeriodic: boolean;
  @Input() titleText: string;
  @Input() payButtonText: string;
  @Input() onlyBlik: boolean;
  @Input() showIcTerms: boolean = false;
  GhostButtonType: typeof GhostButtonType = GhostButtonType;
  selectedPaymentMethod: PaymentMethodType = null;
  PaymentMethodType = PaymentMethodType;
  content: any;
  blikCodeControl: UntypedFormControl;
  env = environment;
  termsAccepted: boolean;
  regulationsAccepted: boolean;
  terms = new UntypedFormGroup({
    autopayTerms: new UntypedFormControl(null, Validators.requiredTrue),
    icTerms: new UntypedFormControl(null, Validators.requiredTrue)
  })

  constructor(
    private translate: TranslateService,
    private location: Location,
    protected router: Router
  ) {
    this.blikCodeControl = new UntypedFormControl(
      null,
      Validators.compose([
        Validators.pattern(ValidationPatterns.requiredOnlyDigit),
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(6)
      ])
    );
  }

  ngOnInit(): void {
    this.translate.get('EXTERNAL_PAYMENTS.CHOOSE_METHOD').subscribe({
      next: (content) => (this.content = content)
    });

    if (this.onlyBlik) {
      this.selectedPaymentMethod = PaymentMethodType.BLIK;
    }

    if (this.isPeriodic) {
      this.selectedPaymentMethod = PaymentMethodType.PAYMENT_CARD;
    }
  }
  checkIfBlikCodeIsInvalid() {
    return this.blikCodeControl.invalid && this.blikCodeControl.touched;
  }


  onSubmit() {
    if (this.selectedPaymentMethod === PaymentMethodType.BLIK && this.blikCodeControl.invalid && this.env.FEATURE_TOGGLES.BLIK_LVL_ZERO) {
      return this.blikCodeControl.markAsTouched();
    }

    if (((this.showIcTerms && !this.terms.get('icTerms').valid) ||
      (!this.terms.get('autopayTerms').valid || !this.blikCodeControl.valid) &&
      this.selectedPaymentMethod === PaymentMethodType.BLIK) ||
      (this.isPeriodic && this.selectedPaymentMethod === PaymentMethodType.PAYMENT_CARD && !this.terms.get('autopayTerms').valid)) {
      this.terms.get('autopayTerms').markAsTouched();
      this.terms.get('icTerms').markAsTouched();
      Extensions.scrollToFirstInvalidInput();
    } else {
      this.submitPaymentMethod.emit({
        paymentType: this.selectedPaymentMethod,
        blikCode: this.blikCodeControl.value
      });
    }
  }

  backClick() {
    this.location.back();
  }
}
